import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <UpdatesSection />
        <FAQSection />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <CardsSection />
        <IndexSection />
        <ContactSection />
        <AboutSection />
        <FeaturesSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}